/* Wanderth — Eliminar items del carrito vía AJAX desde el cart drawer.
   Intercepta clicks en .wanderth-cart-remove[data-cart-key] para evitar la
   navegación al endpoint clásico /cart/change. En su lugar:

   1. Animación de salida (.is-removing) en el item para feedback inmediato
   2. POST a /cart/change.js con quantity=0
   3. Refresh del cart drawer (re-fetch /cart?view=ajax)
   4. Actualizar la burbuja del header

   Si el AJAX falla, se permite que el link siga al endpoint clásico como
   fallback (no se previene el default si hay error). */
(function () {
  'use strict';

  function log() {
    if (window.console && console.log) {
      console.log.apply(console, ['[wanderth-cart-remove]'].concat([].slice.call(arguments)));
    }
  }

  function updateCartBubble(itemCount) {
    document.querySelectorAll('.cart-link__bubble').forEach(function (bubble) {
      if (itemCount > 0) bubble.classList.add('cart-link__bubble--visible');
      else bubble.classList.remove('cart-link__bubble--visible');
    });
    document.querySelectorAll('[data-cart-count], .cart-count').forEach(function (node) {
      node.textContent = String(itemCount);
    });
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    var amount = (cents / 100).toLocaleString('es-CO', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
    return '$' + amount;
  }

  function refreshCartDrawer() {
    var drawer = document.querySelector('#CartDrawer');
    if (!drawer) return Promise.resolve();

    return fetch('/cart?view=ajax&t=' + Date.now(), {
      credentials: 'same-origin',
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // cart.ajax.liquid devuelve un <div class="cart__items"> que va a
        // reemplazar el contenido del [data-products] del drawer.
        var newCartItems = doc.querySelector('.cart__items');
        var currentProducts = drawer.querySelector('[data-products]');
        if (newCartItems && currentProducts) {
          currentProducts.innerHTML = '';
          currentProducts.appendChild(newCartItems);
        }

        // Subtotal — leer cents desde data-cart-subtotal y formatear con money
        var subtotalCents = newCartItems
          ? parseInt(newCartItems.getAttribute('data-cart-subtotal'), 10)
          : 0;
        var currentSubtotal = drawer.querySelector('[data-subtotal]');
        if (currentSubtotal && !isNaN(subtotalCents)) {
          currentSubtotal.innerHTML = formatMoney(subtotalCents);
        }

        // Descuentos cart-wide
        var newDiscounts = doc.querySelector('.cart__discounts');
        var currentDiscounts = drawer.querySelector('[data-discounts]');
        if (currentDiscounts) {
          currentDiscounts.innerHTML = '';
          if (newDiscounts) {
            // Sólo añadir si tiene contenido real (sin la clase .hide)
            if (!newDiscounts.classList.contains('hide')) {
              currentDiscounts.appendChild(newDiscounts);
            }
          }
        }

        // Empty state
        var count = newCartItems
          ? (parseInt(newCartItems.getAttribute('data-count'), 10) || 0)
          : 0;
        drawer.querySelectorAll('.drawer__inner, .drawer__contents, .cart').forEach(function (w) {
          if (count > 0) w.classList.remove('is-empty');
          else w.classList.add('is-empty');
        });

        // Forzar visibilidad de los <image-element> recién inyectados.
        // AOS no observa elementos añadidos dinámicamente, así que les
        // marcamos manualmente la clase .aos-animate (la que dispara la
        // transición de opacity 0 → 1) y, por si acaso, refresh hard.
        if (currentProducts) {
          currentProducts.querySelectorAll('[data-aos]').forEach(function (el) {
            el.classList.add('aos-animate');
          });
        }
        if (window.AOS && typeof AOS.refreshHard === 'function') {
          try { AOS.refreshHard(); } catch (e) { /* noop */ }
        }

        log('Drawer refreshed, items:', count, 'subtotal cents:', subtotalCents);
        return count;
      });
  }

  function removeItem(link) {
    var key = link.getAttribute('data-cart-key');
    if (!key) return;

    var item = link.closest('.cart__item');
    if (item) item.classList.add('is-removing');

    var formData = new FormData();
    formData.append('id', key);
    formData.append('quantity', '0');

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (res) {
        log('POST /cart/change.js status:', res.status);
        if (!res.ok) throw new Error('Remove failed (' + res.status + ')');
        return res.json();
      })
      .then(function (cart) {
        log('cart after remove, item_count:', cart.item_count);
        updateCartBubble(cart.item_count);

        // Esperar a que termine la animación de salida y luego refrescar
        return new Promise(function (resolve) {
          setTimeout(function () {
            refreshCartDrawer().then(resolve);
          }, 250);
        });
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      })
      .catch(function (err) {
        console.error('[wanderth-cart-remove] Error:', err);
        // Restaurar el item si el AJAX falló
        if (item) item.classList.remove('is-removing');
      });
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest
      ? e.target.closest('.wanderth-cart-remove[data-cart-key]')
      : null;
    if (!link) return;

    e.preventDefault();
    if (link.classList.contains('is-removing')) return;
    link.classList.add('is-removing');

    removeItem(link);
  });

  /* ============================================
     Quantity +/- buttons dentro del cart drawer.
     theme.QtySelector adjunta listeners directos a cada botón en init,
     pero al reemplazar el DOM via refreshCartDrawer esos listeners se
     pierden con los botones viejos. Usamos event delegation para que
     funcione siempre, incluso después de inyectar markup nuevo. */
  function changeQuantity(button) {
    var wrapper = button.closest('.js-qty__wrapper');
    if (!wrapper) return;
    if (!button.closest('#CartDrawer')) return;
    if (wrapper.getAttribute('data-changing') === '1') return;

    var input = wrapper.querySelector('.js-qty__num');
    if (!input) return;

    var key = input.getAttribute('data-id');
    if (!key) return;

    var currentQty = parseInt(input.value, 10) || 0;
    var isPlus = button.classList.contains('js-qty__adjust--plus');
    var newQty = isPlus ? currentQty + 1 : Math.max(0, currentQty - 1);

    if (newQty === currentQty) return;

    wrapper.setAttribute('data-changing', '1');

    // Optimistic UI — actualizar input inmediatamente
    input.value = newQty;
    var item = button.closest('.cart__item');
    if (newQty === 0 && item) {
      item.classList.add('is-removing');
    }

    var formData = new FormData();
    formData.append('id', key);
    formData.append('quantity', String(newQty));

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (res) {
        log('POST /cart/change.js qty=' + newQty + ' status:', res.status);
        if (!res.ok) throw new Error('Qty change failed (' + res.status + ')');
        return res.json();
      })
      .then(function (cart) {
        updateCartBubble(cart.item_count);
        // Esperar la animación de salida si se quitó (qty=0)
        var delay = newQty === 0 ? 250 : 0;
        setTimeout(function () { refreshCartDrawer(); }, delay);
      })
      .catch(function (err) {
        console.error('[wanderth-cart-qty] Error:', err);
        // Revertir el input y la animación si el AJAX falló
        input.value = currentQty;
        if (newQty === 0 && item) item.classList.remove('is-removing');
        wrapper.removeAttribute('data-changing');
      });
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest
      ? e.target.closest('.js-qty__adjust--plus, .js-qty__adjust--minus')
      : null;
    if (!button) return;
    if (!button.closest('#CartDrawer')) return;

    e.preventDefault();
    changeQuantity(button);
  });
})();
